/*
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-12-01 16:11:59
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-22 17:08:58
 * @FilePath: \common_web\src\api\archive.js
 */
import request from '@/router/axios'


//获取中介机器运行报表
export function intermediaryMachinehourReport(params) {
  return request({
    url: '/api/device/intermediary/listRunTime',
    method: 'get',
    params
  })
}
//获取销售经理下拉列表
export function salesManagerList(id) {
  return request({
    url: `/api/generalArchive/list/area-code/${id}`,
    method: 'get',
  })
}
//获取总代下拉列表
export function generalList(id) {
  return request({
    url: `/api/generalArchive/list/general-code/${id}`,
    method: 'get',
  })
}
//获取中介总代下店铺分页
export function intermediaryShopPage(params) {
  return request({
    url: '/api/shopStatis/intermediary/page',
    method: 'get',
    params
  })
}
//修改中介总代
export function intermediaryUpdate(params) {
  return request({
    url: '/api/shopStatis/update-intermediary-general',
    method: 'put',
    data: params
  })
}
//获取中介总代列表
export function intermediaryList(params) {
  return request({
    url: '/api/generalArchive/intermediary/list',
    method: 'get',
    params
  })
}
//区代机时查询设置
export function areaMachineTimeSettings(params) {
  return request({
    url: '/api/area-shop-bind',
    method: 'post',
    data: params
  })
}
//获取店铺列表
export function shopList(params) {
  return request({
    url: '/api/shopArchive/base-info/list',
    method: 'get',
    params
  })
}
// 修改系统设置数据
export function submitSystemSet(params) {
  return request({
    url: '/api/blade-system/dict-biz/submit',
    method: 'post',
    data: params
  })
}
//获取系统设置数据
export function getSystemSet(params) {
  return request({
    url: '/api/blade-system/dict-biz/dictionary',
    method: 'get',
    params
  })
}
// 地区列表
export function areaList(params) {
  return request({
    url: '/api/generalArchive/list/proxy-area',
    method: 'get',
    params
  })
}

// 根据区域ID获取总代编码列表
export function getGeneralCode(id) {
  return request({
    url: `/api/generalArchive/list/general-code/${id}`,
    method: 'get'
  })
}

// 根据总代编码ID获取区域编码列表
export function getAreaCode(id) {
  return request({
    url: `/api/generalArchive/list/area-code/${id}`,
    method: 'get'
  })
}
export function shopStatis(query) {
  return request({
    url: '/api/shopStatis',
    method: 'put',
    data: query

  })
}
//店铺名称 编码列表
export function shopApplyDevicelist(params) {
  return request({
    url: '/api/shopArchive/list',
    method: 'get',
    params
  })
}

export function generalMachinehourStatisPage(params) {
  return request({
    url: '/api/generalMachinehourStatis/page',
    method: 'get',
    params: params
  })
}

export function buyrecommend(params) {
  return request({
    url: '/api/machinehour/common/get/buy/recommend',
    method: 'get',
    params:params
  })
}

// 区代名称 编码列表
export function areaArchivelist(params) {
  return request({
    url: '/api/areaArchive/list',
    method: 'get',
    params
  })
}
// 总代 看区代档案列表

export function arealistByCode(query) {
  return request({
    url: '/api/areaStatis/listByCode',
    method: 'get',
    params: query
  })
}

// 总代 区代下店铺列表

export const shopStatisList = (current, size, params) => {
  return request({
      url: '/api/shopStatis/listByCode',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
export const shopStatisPage = (params) => {
  return request({
      url: '/api/shopStatis/listByCode',
    method: 'get',
    params: params
  })
}
// 总代列表
export function genStatisList(query) {
  return request({
    url: '/api/generalStatis/listByCode',
    method: 'get',
    params: query
  })
}
export function generalStatisput(query) {
  return request({
    url: '/api/generalStatis',
    method: 'put',
    data: query
  })
}
export function shopStatisput(query) {
  return request({
    url: '/api/shopStatis',
    method: 'put',
    data: query
  })
}

export function latestShopcode(query) {
  return request({
    url: '/api/shop/machinehour-mode-apply/log/latest/by/shop-code',
    method: 'get',
    params: query
  })
}

export function shopStatisByshopcode(query) {
  return request({
    url: '/api/shopStatis/by-shop-code',
    method: 'get',
    params: query
  })
}
export function logCancel(query) {
  return request({
    url: '/api/shop/machinehour-mode-apply/log/cancel',
    method: 'post',
    data: query
  })
}
export function logAudit(query) {
  return request({
    url: '/api/shop/machinehour-mode-apply/log/audit',
    method: 'post',
    data: query
  })
}
export function logSubmit(query) {
  return request({
    url: '/api/shop/machinehour-mode-apply/log/submit',
    method: 'post',
    data: query
  })
}
export function shopBuyMachinehourGift(query) {
  return request({
    url: '/api/shopBuyMachinehour/general-gift',
    method: 'post',
    data: query
  })
}
export function calculateMinimumConsumptionTime(query) {
  return request({
    url: `/api/shopStatis/calculateMinimumConsumptionTime/${query.id}`,
    method: 'put',
    data: query
  })
}
export function generalStatisUpdate(query) {
  return request({
    url: '/api/generalStatis',
    method: 'put',
    data: query
  })
}


// 总代列表
export function generalUsageGetSetting(query) {
  return request({
    url: '/api/generalUsage/getSetting',
    method: 'get',
    params: query
  })
}

// 总代列表
export function generalUsageUpdateSetting(query) {
  return request({
    url: '/api/generalUsage/updateSetting',
    method: 'get',
    params: query
  })
}


//总代机器解锁店铺列表
export function generalUnlockShopPage(query) {
  return request({
    url: '/api/generalUnlockApply/shop/page',
    method: 'get',
    params: query
  })
}

// 机器删除店铺列表查询
export function delDeviceShopPage(query) {
  return request({
    url: '/api/delDevice/shop/page',
    method: 'get',
    params: query
  })
}

// 机器删除设备列表
export function delDevicePage(query) {
  return request({
    url: '/api/delDevice/device/page',
    method: 'get',
    params: query
  })
}


// 设备移入删除库
export function delDeviceMove(query) {
  return request({
    url: '/api/delDevice/device/move',
    method: 'put',
    data: query
  })
}

// 机器删除设备 彻底
export function delDeviceDel(query) {
  return request({
    url: '/api/delDevice/device/del',
    method: 'delete',
    data: query
  })
}

// 删除库恢复设备
export function restoreDevice(query) {
  return request({
    url: '/api/delDevice/device/restore',
    method: 'put',
    data: query
  })
}


export function factoryUnlockShopPage(query) {
  return request({
    url: '/api/factoryUnlock/shop/page',
    method: 'get',
    params: query
  })
}



//总代机器解锁店铺列表设备
export function generalunlockDevicePage(query) {
  return request({
    url: '/api/generalUnlockApply/device/page',
    method: 'get',
    params: query
  })
}

// 取消申请解锁设备
export function generalUnlockcancelApplyput(query) {
  return request({
    url: '/api/generalUnlockApply/cancelApply',
    method: 'put',
    params: query
  })
}

// 申请解锁设备
export function generalUnlockApplyput(query) {
  return request({
    url: '/api/generalUnlockApply/apply',
    method: 'put',
    params: query
  })
}


// 积分列表
export function integratepage(query) {
  return request({
    url: '/api/integral/shop/page',
    method: 'get',
    params: query
  })
}

// 店铺积分设置
export function queryIntegrate(query) {
  return request({
    url: '/api/integral/queryIntegral',
    method: 'get',
    params: query
  })
}

// 申请解锁设备
export function setIntegrateput(query) {
  return request({
    url: '/api/integral/setIntegral',
    method: 'put',
    data: query
  })
}

// 人员列表
export function userPage(query) {
  return request({
    url: '/api/blade-user/page',
    method: 'get',
    params: query
  })
}

// 人员修改
export function userUpdate(query) {
  return request({
    url: '/api/blade-user/update',
    method: 'post',
    data: query
  })
}

//维保
export function maintenancebindlist(query) {
  return request({
    url: '/api/maintenance/list-bind-maintenance',
    method: 'get',
    params: query
  })
}

export function maintenancebind(query) {
  return request({
    url: '/api/maintenance/bind-maintenance',
    method: 'put',
    data: query
  })
}
export function maintenancelist(query) {
  return request({
    url: '/api/maintenance/list-maintenance',
    method: 'get',
    params: query
  })
}


// 人员新增
export function usersub(query) {
  return request({
    url: '/api/blade-user/submit',
    method: 'post',
    data: query
  })
}
// 合同liebiao
export function shopLeaseContract(query) {
  return request({
    url: '/api/shopLeaseContract/page',
    method: 'get',
    params: query
  })
}

// 合同详情
export function shopLeaseContractdetail(query) {
  return request({
    url: `/api/shopLeaseContract/${query.id}`,
    method: 'get',
    params: query
  })
}

export function shopLeaseContractput(query) {
  return request({
    url: '/api/shopLeaseContract',
    method: 'put',
    data: query
  })
}


// 机器运行档案
export function listRunTime(query) {
  return request({
    url: `/api/device/listRunTime`,
    method: 'get',
    params: query
  })
}

// 机器运行历史记录
export function shopDevicelistByTime(query) {
  return request({
    url: `/api/shopDevice/listByTime`,
    method: 'get',
    params: query
  })
}

// 购机时
export function shopBuyMachinehour(query) {
  return request({
    url: `/api/shopBuyMachinehour/listByTime`,
    method: 'get',
    params: query
  })
}


// 档案审核列表

export function shopArchiveList(query) {
  return request({
    url: `/api/shopArchive/page`,
    method: 'get',
    params: query
  })
}

export function generalArchiveList(query) {
  return request({
    url: `/api/generalArchive/page`,
    method: 'get',
    params: query
  })
}

export function areaArchiveList(query) {
  return request({
    url: `/api/areaArchive/page`,
    method: 'get',
    params: query
  })
}

// 厂家登录总代
export function archivecode(query) {
  return request({
    url: '/api/blade-auth/oauth/token/archive/code',
    method: 'post',
    params: query
  })
}

// 机时相关设置

export function setMaxTime(query) {
  return request({
    url: `/api/factoryUsage/setMaxTime`,
    method: 'get',
    params: query
  })
}

export function getMaxTime(query) {
  return request({
    url: `/api/factoryUsage/getMaxTime`,
    method: 'get',
    params: query
  })
}




export function setFaultTime(query) {
  return request({
    url: `/api/factoryUsage/setFaultTime`,
    method: 'get',
    params: query
  })
}
export function getFaultTime(query) {
  return request({
    url: `/api/factoryUsage/getFaultTime`,
    method: 'get',
    params: query
  })
}




export function setOffLineTime(query) {
  return request({
    url: `/api/factoryUsage/setOffLineTime`,
    method: 'get',
    params: query
  })
}
export function getOffLineTime(query) {
  return request({
    url: `/api/factoryUsage/getOffLineTime`,
    method: 'get',
    params: query
  })
}




export function setNotElectricityTime(query) {
  return request({
    url: `/api/factoryUsage/setNotElectricityTime`,
    method: 'get',
    params: query
  })
}
export function getNotElectricityTime(query) {
  return request({
    url: `/api/factoryUsage/getNotElectricityTime`,
    method: 'get',
    params: query
  })
}





export function setNotWorkTime(query) {
  return request({
    url: `/api/factoryUsage/setNotWorkTime`,
    method: 'get',
    params: query
  })
}
export function getNotWorkTime(query) {
  return request({
    url: `/api/factoryUsage/getNotWorkTime`,
    method: 'get',
    params: query
  })
}




// 获取设备列表
export function getDeviceList(query) {
  return request({
    url: `/api/device/list`,
    method: 'get',
    params: query
  })
}

// 店铺列表分页控制层
export function getGeneralNetworkButton(query) {
  return request({
    url: `/api/generalNetworkButton/page`,
    method: 'get',
    params: query
  })
}

// 开关配网权限
export function getGeneralNetworkButtonTurn(query) {
  return request({
    url: `/api/generalNetworkButton/turnNetwork`,
    method: 'PUT',
    params: query
  })
}


// 店铺列表分页控制层
export function getUpdateTimeRemainingShopPage(query) {
  return request({
    url: `/api/updateTimeRemaining/shop/page`,
    method: 'get',
    params: query
  })
}

// 修改店铺剩余时长
export function updateShopTime(query) {
  return request({
    url: `/api/updateTimeRemaining/update`,
    method: 'GET',
    params: query
  })
}

// 删除人员
export function removeUser(query) {
  console.log(query)
  return request({
    url: '/api/blade-user/remove',
    method: 'post',
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded',
    // },
    params: query
  })
}


// 店铺列表查询（地图使用）
export function getShopArchiveMap(query) {
  return request({
    url: `/api/shopArchive/map/list`,
    method: 'GET',
    params: query
  })
}

//厂家给总代授时
export function generalBuyMachinehour(query) {
  console.log(query)
  return request({
    url: '/api/generalBuyMachinehour',
    method: 'post',

    data: query
  })
}


export const grantTimePage = (current, size, params) => {
  return request({
    url: '/api/grantTime/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export function getResidueDuration(query) {
  return request({
    url: `/api/grantTime/getResidueDuration`,
    method: 'GET',
    params: query
  })
}
export function grantTimedetail(query) {
  return request({
    url: `/api/grantTime/detail`,
    method: 'GET',
    params: query
  })
}
export function getshopResidueDuration(query) {
  return request({
    url: `/api/shopBuyMachinehour/getResidueDuration`,
    method: 'GET',
    params: query
  })
}
export function getgenResidueDuration(query) {
  return request({
    url: `/api/generalBuyMachinehour/getResidueDuration`,
    method: 'GET',
    params: query
  })
}

export function devicePut(obj) {
  return request({
    url: `/api/device`,
    method: 'put',
    data: obj
  })
}

export function turnLayerNum(obj) {
  return request({
    url: `/api/device/turnLayerNum`,
    method: 'put',
    params: obj
  })
}

export function setDeviceBillingModel(obj) {
  return request({
    url: `/api/grantTime/setBillingModel`,
    method: 'get',
    params: obj
  })
}

export function getGrantBaseInfo(obj) {
  return request({
    url: `/api/grantTime/getGrantBaseInfo`,
    method: 'get',
    params: obj
  })
}
export function grantTimestart(obj) {
  return request({
    url: `/api/grantTime/start/${obj.mac}`,
    method: 'get',
    params: obj
  })
}
export function grantTimecheckout(obj) {
  return request({
    url: `/api/grantTime/checkout/${obj.mac}`,
    method: 'get',
    params: obj
  })
}
export function grantTimegrant(obj) {
  return request({
    url: `/api/grantTime/grant/${obj.mac}`,
    method: 'get',
    params: obj
  })
}



export const shopBuyMachinehourPage = (current, size, params,buyType) => {
  return request({
    url: '/api/shopBuyMachinehour/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
      ...buyType
    }
  })
}


export function shopBuyMachinehourdetail(query) {
  return request({
    url: `/api/shopBuyMachinehour/${query.id}`,
    method: 'get',

  })
}
export function genBuyMachinehourdetail(query) {
  return request({
    url: `/api/generalBuyMachinehour/${query.id}`,
    method: 'get',

  })
}



export const genBuyMachinehourPage = (current, size, params) => {
  return request({
    url: '/api/generalBuyMachinehour/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export function precondition(query) {
  return request({
    url: `/api/machinehour/common/query/buy/precondition`,
    method: 'get',
    params: query
  })
}
export function dicDetail(query) {
  return request({
    url: `/api/blade-system/dict-biz/detail`,
    method: 'get',
    params: query
  })
}

// 查询字典列表
export function getDictionary(query) {
  return request({
    url: `/api/blade-system/dict-biz/dictionary`,
    method: 'get',
    params: query
  })
}

// 提交字典（新增或修改）
export function submitDictionary(query) {
  return request({
    url: `/api/blade-system/dict-biz/submit`,
    method: 'post',
    data: query
  })
}

export function packagesList(query) {
  return request({
    url: `/api/packages/list`,
    method: 'get',
    params: query
  })
}

export function shopBuyMachinehourAdd(query) {
  return request({
    url: `/api/shopBuyMachinehour`,
    method: 'post',
    data: query
  })
}
export function shopBuyMachinehourput(query) {
  return request({
    url: `/api/shopBuyMachinehour`,
    method: 'put',
    data: query
  })
}

export function genBuyMachinehourAdd(query) {
  return request({
    url: `/api/generalBuyMachinehour`,
    method: 'post',
    data: query
  })
}
export function genBuyMachinehourput(query) {
  return request({
    url: `/api/generalBuyMachinehour`,
    method: 'put',
    data: query
  })
}

export function shopBuyMachinehourcheck(query) {
  return request({
    url: `/api/shopBuyMachinehour/check`,
    method: 'post',
    data: query
  })
}
export function shopBuyMachinehourcancel(query) {
  return request({
    url: `/api/shopBuyMachinehour/cancel`,
    method: 'post',
    data: query
  })
}
export function shopBuyMachinehourReceive(query) {
  return request({
    url: `/api/shopBuyMachinehour/receive`,
    method: 'post',
    data: query
  })
}

export function genBuyMachinehourcheck(query) {
  return request({
    url: `/api/generalBuyMachinehour/check`,
    method: 'post',
    data: query
  })
}
export function genBuyMachinehourcancel(query) {
  return request({
    url: `/api/generalBuyMachinehour/cancel`,
    method: 'post',
    data: query
  })
}
export function genBuyMachinehourReceive(query) {
  return request({
    url: `/api/generalBuyMachinehour/receive`,
    method: 'post',
    data: query
  })
}

export const packagesTreePage = (current, size, params) => {
  return request({
    url: '/api/packages/tree/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export function packagesAdd(query) {
  return request({
    url: `/api/packages`,
    method: 'post',
    data: query
  })
}
export function packagesPut(query) {
  return request({
    url: `/api/packages`,
    method: 'put',
    data: query
  })
}
export function packagesDel(query) {
  return request({
    url: `/api/packages/${query.id}`,
    method: 'delete',

  })
}
